/** @jsx h */
import { h } from 'preact'
import CloseIcon from '../icons/CloseIcon'

const handleClick = () => {
  // if we are using zoid.js send message via xprops
  if (window.xprops) {
    window.xprops.closeModal()
  } else {
    // else use our embed messaging system
    const secret = window.location.hash.replace(
      /.*secret=([\d\w]{10}).*/,
      '$1'
    )
    window.parent.postMessage(
      {
        message: 'close',
        value: '',
        secret
      },
      '*'
    )
  }
}

const JourneyClose = props => {
  // do not show if not within an iframe
  // or if not an old version of the SDK
  if (window.self === window.top || (window.xprops && window.xprops.version)) return null

  const { size } = props

  return (
    <button
      class={`JourneyClose Action-close Action-close--${size}`}
      onClick={handleClick}
      type='button'
    >
      <CloseIcon />
    </button>
  )
}

JourneyClose.defaultProps = {
  size: 'default'
}

export default JourneyClose
